import React, { Suspense } from 'react';
import { LocalStorageService } from 'br2s-ui-common-utils-02';
import InstructionWrapper from '@/components/InstructionWrapper/InstructionWrapper';
import Loading from '@/components/Loading';
import {
  MAGNOLIA_PATHS,
  POST_LOGIN_INSTRUCTION_REROUTES,
} from '@/utilities/constants/instructions';
import { useStore } from '@/redux/store';
import { checkIfShouldSfv } from '@/utilities/utilities';

const PageLoaderModule = React.lazy(() => import('content/PageLoaderModule'));

export type InstructionPageProps = {
  id: string;
  path: keyof typeof POST_LOGIN_INSTRUCTION_REROUTES;
  type?: 'mgnl' | 'custom';
  mgnlPagePath?: (typeof MAGNOLIA_PATHS)[keyof typeof MAGNOLIA_PATHS];
  element?: () => JSX.Element;
};

const InstructionPage = ({
  id: pageId,
  path,
  mgnlPagePath,
  type = 'mgnl',
  element: InstructionComponent,
}: InstructionPageProps) => {
  const { toggleSfvAttempt } = useStore();
  const postLoginInstructionPath = POST_LOGIN_INSTRUCTION_REROUTES[path];

  const handleStartTransaction = () => {
    const loginModalEvt = new CustomEvent('openLoginModal');
    window.dispatchEvent(loginModalEvt);
    LocalStorageService.setUrlPriorToLogin(postLoginInstructionPath);
    if (checkIfShouldSfv(postLoginInstructionPath)) {
      toggleSfvAttempt();
    }
  };

  return (
    <InstructionWrapper id={pageId} onTransactionStart={handleStartTransaction}>
      {type === 'custom' && !!InstructionComponent ? (
        <InstructionComponent />
      ) : (
        <Suspense fallback={<Loading />}>
          <PageLoaderModule pagePath={mgnlPagePath} />
        </Suspense>
      )}
    </InstructionWrapper>
  );
};

export default InstructionPage;
